const userData = [
  {
    step: 'Step 1',
    title: 'Understanding your requirements & goals',
    content:
      'Our consultant will discuss over a session to understand your ideas, goals, needs of the team. The outcome of this discussion will be the tech stack, team size, budget, project timeline etc.',
  },
  {
    step: 'Step 2',
    title: 'Needs Assessment & Resume sharing',
    content:
      'We will assess challenges of the project, the needed skillset to solve these challenges. As an outcome of this assessment we provide you with a list of CVs (potential candidates) with you. You can select candidates. This works in cases of Extended & Remote Teams.',
  },
  {
    step: 'Step 3',
    title: 'Assigning PIC',
    content:
      'Once you finalize the team, a PIC (usually a Project Manager or Team Lead/Architect) will be assigned for all project/delivery related',
  },
  {
    step: 'Step 4',
    title: 'Contract',
    content:
      'At this point, we can formalize & sign a mutual contract. The contract mentions details about the project team size, deliverables, timelines. It Can additionally include NDA.',
  },
  {
    step: 'Step 5',
    title: 'Start working with the team!',
    content:
      'We suggest 2 weeks of team onboarding to understand your engineering culture, processes, knowledge transfer for a smooth transition and integration into your teams. This is particularly helpful for remote teams and/or geographically distributed',
  }
];
export default userData